import { momoDialString } from '../splitReceipt/model';
import { PaymentData, PaymentLinkDestination } from '../types/PaymentData';

/** The vendor from `GET /api/payment-links/:token`, or null when the link pays the sender. */
export function parseDestination(raw: unknown): PaymentLinkDestination | null {
    const value = raw as { type?: unknown; code?: unknown; name?: unknown } | null | undefined;
    if (!value || value.type !== 'vendor' || typeof value.code !== 'string' || !value.code.trim()) {
        return null;
    }
    const name = typeof value.name === 'string' ? value.name.trim() : '';
    return { type: 'vendor', code: value.code.trim(), ...(name ? { name } : {}) };
}

/** "Kigali Heights", or "Vendor 123456" when the organizer gave no name. */
export function vendorLabel(destination: PaymentLinkDestination): string {
    return destination.name?.trim() || `Vendor ${destination.code}`;
}

/** Vendor links pay the merchant code; the rest pay the sender's MoMo number. */
export function paymentDial(data: PaymentData): string {
    const vendor = data.destination;
    return vendor
        ? momoDialString({ type: 'merchant', name: vendorLabel(vendor), identifier: vendor.code }, data.amount)
        : momoDialString({ type: 'creator', name: data.sender.name, identifier: data.sender.phoneNumber }, data.amount);
}
